export default __webpack_public_path__ + "static/media/fourtyYard.537b8877.jpg";